import { PRICE_RANGE } from 'Pods/SearchPage/Store/constants'

export const priceRangeOptions = [
  {
    value: PRICE_RANGE.FREE,
    labelKey: 'free',
  },
  {
    value: PRICE_RANGE.RANGE_2_10,
    labelKey: 'range_2_10',
  },
  {
    value: PRICE_RANGE.RANGE_10_20,
    labelKey: 'range_10_20',
  },
  {
    value: PRICE_RANGE.RANGE_20_50,
    labelKey: 'range_20_50',
  },
  {
    value: PRICE_RANGE.RANGE_50_100,
    labelKey: 'range_50_100',
  },
  {
    value: PRICE_RANGE.MORE_THAN_100,
    labelKey: 'more_than_100',
  },
]
